// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p,
h1 {
  margin: unset;
}

ion-header {
  box-shadow: none;
}

.toolbar {
  background: var(--background-default);
  flex-wrap: nowrap !important;
  display: flex;
}
.toolbar p {
  color: white;
  font-size: 10px;
}

.category-block {
  background: #ffffff;
}

ion-content {
  background: var(--ion-color-secondary) !important;
  --background: var(--ion-color-secondary) !important;
}

ion-icon.brand-logo {
  width: 140px;
  height: 18px;
}

.main {
  overflow: auto;
}

.item-responsive {
  width: 100%;
}
@media (min-width: 991px) {
  .item-responsive {
    width: calc(33.333% - 10px);
    margin: 0 5px 10px;
  }
}

ion-searchbar {
  padding-inline-end: 25px;
  padding-inline-start: 25px;
  --placeholder-color: var(--ion-color-medium);
  --placeholder-opacity: 1;
  --color: var(--ion-color-medium);
  --icon-color: var(--ion-color-medium);
  --border-radius: 3px;
  --border: 1px solid var(--ion-color-medium);
  --background: var(--color-white);
}
@media (min-width: 991px) {
  ion-searchbar {
    width: auto;
  }
}

.menu-heading {
  padding-top: 10px;
  background: #e7f0f1;
  padding-bottom: 10px;
}
@media (min-width: 991px) {
  .menu-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7f0f1;
  }
}

.list-title {
  margin-bottom: 15px;
}

.orders {
  overflow: auto;
  flex: 1;
  padding-bottom: 10px;
}

.items-wrap h3 {
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: bolder;
}
.items-wrap:first-of-type {
  padding-top: 12px;
}
.items-wrap:last-of-type {
  padding-bottom: 400px;
}
.items-wrap .category-wrap {
  margin-bottom: 22px;
}
.items-wrap .articles-wrapper {
  padding-inline: 16px;
}
@media (min-width: 991px) {
  .items-wrap .articles-wrapper {
    margin: 0 -16px;
  }
}

.main-row {
  height: 100%;
  overflow: hidden;
}

app-order-content {
  display: block;
  height: 100%;
}

.order-col {
  min-width: 380px;
}

.category-header {
  height: 80px;
  width: 100%;
  position: relative;
}
.category-header .category-headr-img {
  height: 80px;
  width: 100%;
  object-fit: cover;
  opacity: 0.7;
  z-index: 0.6;
}
.category-header h3 {
  position: absolute;
  z-index: 10;
  top: 50%;
  color: var(--ion-color-primary);
  left: 25px;
  transform: translateY(-50%);
}
@media (min-width: 991px) {
  .category-header {
    margin-top: 20px;
  }
}

.category-info {
  padding-left: 16px;
  height: 77px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  background-size: cover !important;
  background-position: center bottom !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background: linear-gradient(rgba(64, 130, 28, 0.4), rgba(64, 130, 28, 0.4)), url('home_bg.png') !important;
}
.category-info .category-name {
  width: 100%;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
  z-index: 9999;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  color: var(--ion-color-secondary);
}
.category-info .category-description {
  z-index: 1;
  font-family: AppFont;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  color: #fff;
  margin-top: 7px;
}
.category-info .category-bg {
  object-fit: cover;
  right: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  position: absolute;
}
.category-info .category-logo {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 70px;
  height: auto;
  z-index: 2;
  pointer-events: none;
}

.header-wrap {
  padding-left: 11px;
}

.padding-end {
  padding-right: 11px;
}

.footer-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  backdrop-filter: blur(4px);
  background: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.25);
}
@media (min-width: 991px) {
  .footer-btn {
    display: none;
  }
}

.category-list {
  display: flex;
  align-items: center;
  transition: 1s linear;
  opacity: 1;
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  background-color: var(--ion-color-secondary);
  height: 55px;
  padding-inline: 16px;
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list .category {
  flex: 0 0 auto;
}
.category-list .category:first-child {
  margin-left: 15px;
}
.category-list .category:last-child {
  margin-right: 15px;
}

.menu-heading {
  padding-top: 10px;
  background: #6b5f4c;
  padding-bottom: 10px;
}
@media (min-width: 991px) {
  .menu-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7f0f1;
  }
}

.search-block {
  height: 71px;
  display: flex;
  align-items: center;
  opacity: 1;
  transition: 1s linear;
  background-color: var(--ion-color-secondary);
}

.hidden {
  opacity: 0;
  display: none;
  transition: 1s linear;
}

.main-row {
  height: 100%;
  overflow: hidden;
}

ion-chip {
  --icon-color: var(--ion-color-medium);
  height: 39px;
  background: var(--color-white);
  border: 1px solid var(--ion-color-medium);
  transition: 200ms linear;
  min-width: 39px;
  flex-direction: column;
  padding: 0 12px !important;
  border-radius: 3px;
  justify-content: center;
}
ion-chip ion-label {
  font-size: 14px;
  margin: 0;
  color: var(--ion-color-medium);
  font-family: AppFont, sans-serif;
}
ion-chip.selected {
  font-family: AppFont;
  font-weight: 400;
  transition: 200ms linear;
  background: var(--ion-color-tertiary);
  border-color: var(--ion-color-tertiary);
  position: relative;
}
ion-chip.selected ion-label {
  color: var(--ion-color-dark);
}
ion-chip .icon {
  height: 17px;
  width: 17px;
  margin: 0;
}

.service-not-available-container {
  --padding-start: 20px !important;
  --padding-end: 10px;
  --padding-top: 10px;
  --padding-bottom: 10px;
}
.service-not-available-container ion-icon {
  color: #fff !important;
}

.banner-row {
  height: 48px;
  overflow: hidden;
  transition: transform 1s ease-in-out, height 1s ease-in-out;
}
@media (max-width: 992px) {
  .banner-row {
    height: 60px;
  }
}
.banner-row.hide {
  height: 0;
  transform: rotateX(45deg) translate(0, -150%);
}

.allergen-banner {
  height: 100%;
  background: var(--color-btn-recomendation);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px !important;
  padding-right: 16px;
}
.allergen-banner ion-icon {
  fill: var(--color-black);
  margin-right: 15px;
  height: 27px;
  width: 32px;
}
.allergen-banner .info {
  width: 100%;
  margin: 0;
  padding-block: 5px;
  font-family: AppFont !important;
  font-size: 10px !important;
  line-height: 13.2px !important;
  color: var(--color-black) !important;
  text-wrap: balance;
}
.allergen-banner a {
  font-family: AppFontSemiBold;
  font-size: 10px;
  color: var(--ion-color-primary);
  text-decoration: underline;
}

.expand-block {
  position: fixed;
  height: 100vh;
  width: 100vw;
  right: -100%;
  top: 0;
  background: rgba(0, 0, 0, 0.1019607843);
  z-index: 10;
}
@media (max-width: 992px) {
  .expand-block {
    display: none;
  }
}
.expand-block.show {
  right: 0%;
}

.sidebar {
  position: absolute;
  right: -100%;
  top: 0;
  width: 35vw;
  height: 100vh;
  background: #fff;
  z-index: 11;
  display: flex;
  flex-direction: column;
  transition: right 0.3s ease-in-out;
}
@media (max-width: 992px) {
  .sidebar {
    display: none;
  }
}
.sidebar.show {
  right: 0%;
}

app-order-content {
  display: block;
  height: 100%;
  background: #f2f2f2;
}

.fixed-notification {
  pointer-events: none;
  position: fixed;
  bottom: 86px;
  left: 50%;
  transform: translateX(-50%);
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(30, 30, 28, 0.5803921569);
  backdrop-filter: blur(4px);
  z-index: 9999;
  opacity: 0;
  transition: 0.3s ease;
}
@media (min-width: 991px) {
  .fixed-notification {
    bottom: 0px;
  }
}
.fixed-notification::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -12px;
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-top: 12px solid rgba(30, 30, 28, 0.5803921569);
  backdrop-filter: blur(4px);
}
.fixed-notification ::ng-deep.inner-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #fff;
  padding: 0 10px;
}
.fixed-notification ::ng-deep.inner-text span {
  font-family: AppFontSemiBold;
  color: #fff;
}

.placeholder-item {
  height: 200px;
}

.fixed-notification.show-item {
  opacity: 1;
}

.tag-wrapper-wrapper {
  width: 100%;
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  margin-top: -12px;
}
@media (max-width: 992px) {
  .tag-wrapper-wrapper {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}
.tag-wrapper-wrapper::-webkit-scrollbar {
  display: none;
}
.tag-wrapper-wrapper .tag-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin: 0 auto;
  padding: 5px 10px;
  margin-bottom: 15px;
}
.tag-wrapper-wrapper .tag-wrapper .tag-block {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: center;
  height: 39px;
  background: var(--color-white);
  border: 1px solid var(--ion-color-medium);
  transition: 200ms linear;
  min-width: 39px;
  width: max-content;
  padding: 0 12px !important;
  border-radius: 3px;
  font-family: AppFont, sans-serif;
  font-size: 14px;
  margin: 0;
  color: var(--ion-color-medium);
}
.tag-wrapper-wrapper .tag-wrapper .tag-block.selected {
  font-family: AppFont;
  font-weight: 400;
  transition: 200ms linear;
  background: var(--ion-color-tertiary);
  border-color: var(--ion-color-tertiary);
  position: relative;
  color: var(--ion-color-black);
}
.tag-wrapper-wrapper .tag-wrapper .tag-block.selected ion-label {
  color: var(--ion-color-black);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;;EAEC,aAAA;AAAD;;AAGA;EACC,gBAAA;AAAD;;AAGA;EACC,qCAAA;EACA,4BAAA;EACA,aAAA;AAAD;AACC;EACC,YAAA;EACA,eAAA;AACF;;AAGA;EACC,mBAAA;AAAD;;AAEA;EACC,iDAAA;EACA,mDAAA;AACD;;AACA;EACC,YAAA;EACA,YAAA;AAED;;AACA;EACC,cAAA;AAED;;AACA;EACC,WAAA;AAED;ACtCE;EDmCF;IAGE,2BAAA;IACA,kBAAA;EAIA;AACF;;AADA;EACC,wBAAA;EACA,0BAAA;EACA,4CAAA;EACA,wBAAA;EACA,gCAAA;EACA,qCAAA;EACA,oBAAA;EACA,2CAAA;EACA,gCAAA;AAID;ACxDE;ED2CF;IAWE,WAAA;EAMA;AACF;;AAJA;EACC,iBAAA;EACA,mBAAA;EACA,oBAAA;AAOD;ACnEE;EDyDF;IAKE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,gCAAA;EASA;AACF;;AANA;EACC,mBAAA;AASD;;AANA;EACC,cAAA;EACA,OAAA;EACA,oBAAA;AASD;;AALC;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;AAQF;AALC;EACC,iBAAA;AAOF;AAJC;EACC,qBAAA;AAMF;AAHC;EACC,mBAAA;AAKF;AAFC;EACC,oBAAA;AAIF;ACvGE;EDkGD;IAGE,eAAA;EAMD;AACF;;AAFA;EACC,YAAA;EACA,gBAAA;AAKD;;AAFA;EACC,cAAA;EACA,YAAA;AAKD;;AAFA;EACC,gBAAA;AAKD;;AAHA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAMD;AALC;EACC,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AAOF;AALC;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,+BAAA;EACA,UAAA;EACA,2BAAA;AAOF;AC/IE;EDuHF;IAoBE,gBAAA;EAQA;AACF;;AANA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACG,iCAAA;EACA,6CAAA;EACA,uCAAA;EACA,uCAAA;EACA,0GACM;AAQV;AAJC;EACC,WAAA;EAEA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EAEA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;AAIF;AADC;EACC,UAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AAGF;AAAC;EACC,iBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAEF;AACC;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;AACF;;AAGA;EACC,kBAAA;AAAD;;AAEA;EACC,mBAAA;AACD;;AAEA;EACC,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,0BAAA;EACA,4GAAA;EACA,0CAAA;AACD;AClOE;EDyNF;IAUE,aAAA;EAGA;AACF;;AADA;EACC,aAAA;EACA,mBAAA;EAEA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;EAEA,4CAAA;EACA,YAAA;EACA,oBAAA;AAED;AAAC;EACC,aAAA;AAEF;AACC;EACC,cAAA;AACF;AACE;EACC,iBAAA;AACH;AAEE;EACC,kBAAA;AAAH;;AAIA;EACC,iBAAA;EACA,mBAAA;EACA,oBAAA;AADD;ACxQE;EDsQF;IAKE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,gCAAA;EACA;AACF;;AAKA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EAEA,UAAA;EACA,qBAAA;EACG,4CAAA;AAHJ;;AAKA;EACC,UAAA;EACA,aAAA;EACA,qBAAA;AAFD;;AAKA;EACC,YAAA;EACA,gBAAA;AAFD;;AAIA;EACC,qCAAA;EACA,YAAA;EAEA,8BAAA;EACA,yCAAA;EACA,wBAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EAGA,uBAAA;AAJD;AAMC;EACC,eAAA;EACA,SAAA;EACA,8BAAA;EACA,gCAAA;AAJF;AAOC;EACO,oBAAA;EACA,gBAAA;EACN,wBAAA;EACA,qCAAA;EACA,uCAAA;EACM,kBAAA;AALR;AAOE;EACC,4BAAA;AALH;AASC;EACC,YAAA;EACA,WAAA;EACA,SAAA;AAPF;;AAWA;EACC,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AARD;AASC;EACC,sBAAA;AAPF;;AAWA;EACC,YAAA;EACA,gBAAA;EACA,2DACC;AATF;ACjVE;EDsVF;IAOE,YAAA;EARA;AACF;AAUC;EACC,SAAA;EACA,6CAAA;AARF;;AAYA;EACC,YAAA;EACA,0CAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mBAAA;AAVD;AAYC;EACC,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAVF;AAaC;EACC,WAAA;EACA,SAAA;EACA,kBAAA;EAEA,+BAAA;EACA,0BAAA;EACA,8BAAA;EAEA,oCAAA;EACA,kBAAA;AAbF;AAgBC;EACC,4BAAA;EACA,eAAA;EACA,+BAAA;EACA,0BAAA;AAdF;;AAkBA;EACC,eAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,uCAAA;EAEA,WAAA;AAhBD;ACpYE;ED4YF;IAUE,aAAA;EAdA;AACF;AAeC;EACC,SAAA;AAbF;;AAiBA;EACC,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EAEA,aAAA;EACA,sBAAA;EAEA,kCAAA;AAhBD;ACzZE;ED6ZF;IAcE,aAAA;EAdA;AACF;AAeC;EACC,SAAA;AAbF;;AAiBA;EACC,cAAA;EACA,YAAA;EACA,mBAAA;AAdD;;AAiBA;EACC,oBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EAEA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,0CAAA;EACA,0BAAA;EAEA,aAAA;EACA,UAAA;EACA,qBAAA;AAjBD;AC/bE;ED8bF;IAoBE,WAAA;EAfA;AACF;AAiBC;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,qDAAA;EACA,0BAAA;AAfF;AAkBC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AAhBF;AAiBE;EACC,4BAAA;EACA,WAAA;AAfH;;AAoBA;EACC,aAAA;AAjBD;;AAoBA;EACC,UAAA;AAjBD;;AAoBA;EACC,WAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AAjBD;ACxeE;EDofF;IAQE,wBAAA;IACA,qBAAA;EAhBA;AACF;AAiBC;EACC,aAAA;AAfF;AAkBC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAhBF;AAkBE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,yCAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EAEA,gCAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;AAjBH;AAmBU;EACE,oBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qCAAA;EACA,uCAAA;EACA,kBAAA;EACA,6BAAA;AAjBZ;AAmBY;EACE,6BAAA;AAjBd","sourcesContent":["@use '../../../theme/mixins' as *;\np,\nh1 {\n\tmargin: unset;\n}\n\nion-header {\n\tbox-shadow: none;\n}\n\n.toolbar {\n\tbackground: var(--background-default);\n\tflex-wrap: nowrap !important;\n\tdisplay: flex;\n\tp {\n\t\tcolor: white;\n\t\tfont-size: 10px;\n\t}\n}\n\n.category-block {\n\tbackground: #ffffff;\n}\nion-content {\n\tbackground: var(--ion-color-secondary) !important;\n\t--background: var(--ion-color-secondary) !important;\n}\nion-icon.brand-logo {\n\twidth: 140px;\n\theight: 18px;\n}\n\n.main {\n\toverflow: auto;\n}\n\n.item-responsive {\n\twidth: 100%;\n\t@include desktop {\n\t\twidth: calc(33.333% - 10px);\n\t\tmargin: 0 5px 10px;\n\t}\n}\n\nion-searchbar {\n\tpadding-inline-end: 25px;\n\tpadding-inline-start: 25px;\n\t--placeholder-color: var(--ion-color-medium);\n\t--placeholder-opacity: 1;\n\t--color: var(--ion-color-medium);\n\t--icon-color: var(--ion-color-medium);\n\t--border-radius: 3px;\n\t--border: 1px solid var(--ion-color-medium);\n\t--background: var(--color-white);\n\t@include desktop {\n\t\twidth: auto;\n\t}\n}\n.menu-heading {\n\tpadding-top: 10px;\n\tbackground: #e7f0f1;\n\tpadding-bottom: 10px;\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 1px solid #e7f0f1;\n\t}\n}\n\n.list-title {\n\tmargin-bottom: 15px;\n}\n\n.orders {\n\toverflow: auto;\n\tflex: 1;\n\tpadding-bottom: 10px;\n}\n\n.items-wrap {\n\th3 {\n\t\tmargin-top: 0;\n\t\tmargin-bottom: 12px;\n\t\tfont-weight: bolder;\n\t}\n\n\t&:first-of-type {\n\t\tpadding-top: 12px;\n\t}\n\n\t&:last-of-type {\n\t\tpadding-bottom: 400px;\n\t}\n\n\t.category-wrap {\n\t\tmargin-bottom: 22px;\n\t}\n\n\t.articles-wrapper {\n\t\tpadding-inline: 16px;\n\t\t@include desktop {\n\t\t\tmargin: 0 -16px;\n\t\t}\n\t}\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n}\n\n.order-col {\n\tmin-width: 380px;\n}\n.category-header {\n\theight: 80px;\n\twidth: 100%;\n\tposition: relative;\n\t.category-headr-img {\n\t\theight: 80px;\n\t\twidth: 100%;\n\t\tobject-fit: cover;\n\t\topacity: 0.7;\n\t\tz-index: 0.6;\n\t}\n\th3 {\n\t\tposition: absolute;\n\t\tz-index: 10;\n\t\ttop: 50%;\n\t\tcolor: var(--ion-color-primary);\n\t\tleft: 25px;\n\t\ttransform: translateY(-50%);\n\t}\n\t@include desktop {\n\t\tmargin-top: 20px;\n\t}\n}\n.category-info {\n\tpadding-left: 16px;\n\theight: 77px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: flex-start;\n\tposition: relative;\n    background-size: cover !important;\n    background-position: center bottom !important;\n    background-repeat: no-repeat !important;\n    background-attachment: fixed !important;\n    background:\n          linear-gradient(rgba(64, 130, 28, 0.4), rgba(64, 130, 28, 0.4)),\n          url('../../../assets/el-kiosko/home_bg.png') !important;\n    //background-image: url('../../../assets/el-kiosko/home_bg.png') !important;\n\n\t.category-name {\n\t\twidth: 100%;\n\n\t\tword-break: break-word;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tmargin: 0px;\n\t\tz-index: 9999;\n\n\t\tfont-size: 20px;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n\n\t.category-description {\n\t\tz-index: 1;\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0;\n\t\tvertical-align: middle;\n\t\tcolor: #fff;\n\t\tmargin-top: 7px;\n\t}\n\n\t.category-bg {\n\t\tobject-fit: cover;\n\t\tright: 0px;\n\t\ttop: 0px;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t}\n\n\t.category-logo {\n\t\tposition: absolute;\n\t\tright: 12px;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\twidth: 70px;\n\t\theight: auto;\n\t\tz-index: 2;\n\t\tpointer-events: none;\n\t}\n}\n\n.header-wrap {\n\tpadding-left: 11px;\n}\n.padding-end {\n\tpadding-right: 11px;\n}\n\n.footer-btn {\n\tposition: fixed;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpadding: 16px;\n\tbackdrop-filter: blur(4px);\n\tbackground: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);\n\tbox-shadow: 0 -2px 5px rgba(0, 0, 0, 0.25);\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n.category-list {\n\tdisplay: flex;\n\talign-items: center;\n\n\ttransition: 1s linear;\n\topacity: 1;\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none; /* Firefox */\n\n\tbackground-color: var(--ion-color-secondary);\n\theight: 55px;\n\tpadding-inline: 16px;\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t.category {\n\t\tflex: 0 0 auto;\n\n\t\t&:first-child {\n\t\t\tmargin-left: 15px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-right: 15px;\n\t\t}\n\t}\n}\n.menu-heading {\n\tpadding-top: 10px;\n\tbackground: #6b5f4c;\n\tpadding-bottom: 10px;\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 1px solid #e7f0f1;\n\t}\n}\n// .first {\n// \tmargin-top: 10px;\n// }\n\n.search-block {\n\theight: 71px;\n\tdisplay: flex;\n\talign-items: center;\n\n\topacity: 1;\n\ttransition: 1s linear;\n    background-color: var(--ion-color-secondary);\n}\n.hidden {\n\topacity: 0;\n\tdisplay: none;\n\ttransition: 1s linear;\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n}\nion-chip {\n\t--icon-color: var(--ion-color-medium);\n\theight: 39px;\n\n\tbackground: var(--color-white);\n\tborder: 1px solid var(--ion-color-medium);\n\ttransition: 200ms linear;\n\tmin-width: 39px;\n\tflex-direction: column;\n\tpadding: 0 12px !important;\n\tborder-radius: 3px;\n\t// text-transform: uppercase;\n\n\tjustify-content: center;\n\n\tion-label {\n\t\tfont-size: 14px;\n\t\tmargin: 0;\n\t\tcolor: var(--ion-color-medium);\n\t\tfont-family: AppFont, sans-serif;\n\t}\n\n\t&.selected {\n        font-family: AppFont;\n        font-weight: 400;\n\t\ttransition: 200ms linear;\n\t\tbackground: var(--ion-color-tertiary);\n\t\tborder-color: var(--ion-color-tertiary);\n        position: relative;\n\n\t\tion-label {\n\t\t\tcolor: var(--ion-color-dark);\n\t\t}\n\t}\n\n\t.icon {\n\t\theight: 17px;\n\t\twidth: 17px;\n\t\tmargin: 0;\n\t}\n}\n\n.service-not-available-container {\n\t--padding-start: 20px !important;\n\t--padding-end: 10px;\n\t--padding-top: 10px;\n\t--padding-bottom: 10px;\n\tion-icon {\n\t\tcolor: #fff !important;\n\t}\n}\n\n.banner-row {\n\theight: 48px;\n\toverflow: hidden;\n\ttransition:\n\t\ttransform 1s ease-in-out,\n\t\theight 1s ease-in-out;\n\t@include mobile {\n\t\theight: 60px;\n\t}\n\n\t&.hide {\n\t\theight: 0;\n\t\ttransform: rotateX(45deg) translate(0, -150%);\n\t}\n}\n\n.allergen-banner {\n\theight: 100%;\n\tbackground: var(--color-btn-recomendation);\n\t// height: 39px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding-left: 16px !important;\n\tpadding-right: 16px;\n\n\tion-icon {\n\t\tfill: var(--color-black);\n\t\tmargin-right: 15px;\n\t\theight: 27px;\n\t\twidth: 32px;\n\t}\n\n\t.info {\n\t\twidth: 100%;\n\t\tmargin: 0;\n\t\tpadding-block: 5px;\n\n\t\tfont-family: AppFont !important;\n\t\tfont-size: 10px !important;\n\t\tline-height: 13.2px !important;\n\n\t\tcolor: var(--color-black) !important;\n\t\ttext-wrap: balance;\n\t}\n\n\ta {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 10px;\n\t\tcolor: var(--ion-color-primary);\n\t\ttext-decoration: underline;\n\t}\n}\n\n.expand-block {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100vw;\n\tright: -100%;\n\ttop: 0;\n\tbackground: #0000001a;\n\n\tz-index: 10;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t&.show {\n\t\tright: 0%;\n\t}\n}\n\n.sidebar {\n\tposition: absolute;\n\tright: -100%;\n\ttop: 0;\n\twidth: 35vw;\n\theight: 100vh;\n\tbackground: #fff;\n\tz-index: 11;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\ttransition: right 0.3s ease-in-out;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t&.show {\n\t\tright: 0%;\n\t}\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n\tbackground: #f2f2f2;\n}\n\n.fixed-notification {\n\tpointer-events: none;\n\tposition: fixed;\n\tbottom: 86px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\n\theight: 60px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tbackground: #1e1e1c94;\n\tbackdrop-filter: blur(4px);\n\n\tz-index: 9999;\n\topacity: 0;\n\ttransition: 0.3s ease;\n\t@include desktop {\n\t\tbottom: 0px;\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\tbottom: -12px;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-left: 14px solid transparent;\n\t\tborder-right: 14px solid transparent;\n\t\tborder-top: 12px solid #1e1e1c94;\n\t\tbackdrop-filter: blur(4px);\n\t}\n\n\t::ng-deep.inner-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\tcolor: #fff;\n\t\tpadding: 0 10px;\n\t\tspan {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}\n\n.placeholder-item {\n\theight: 200px;\n}\n\n.fixed-notification.show-item {\n\topacity: 1;\n}\n\n.tag-wrapper-wrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\tmargin-top: -12px;\n\n\t@include mobile {\n\t\t-ms-overflow-style: none;\n\t\tscrollbar-width: none;\n\t}\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t.tag-wrapper {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 6px;\n\t\tmargin: 0 auto;\n\t\tpadding: 5px 10px;\n\t\tmargin-bottom: 15px;\n\n\t\t.tag-block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tjustify-content: center;\n\t\t\theight: 39px;\n\t\t\tbackground: var(--color-white);\n\t\t\tborder: 1px solid var(--ion-color-medium);\n\t\t\ttransition: 200ms linear;\n\t\t\tmin-width: 39px;\n\t\t\twidth: max-content;\n\t\t\tpadding: 0 12px !important;\n\t\t\tborder-radius: 3px;\n\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tmargin: 0;\n\t\t\tcolor: var(--ion-color-medium);\n\n          &.selected {\n            font-family: AppFont;\n            font-weight: 400;\n            transition: 200ms linear;\n            background: var(--ion-color-tertiary);\n            border-color: var(--ion-color-tertiary);\n            position: relative;\n            color: var(--ion-color-black);\n\n            ion-label {\n              color: var(--ion-color-black);\n            }\n          }\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
